export const NewEditCategoryEnum = {
  NEW: '0',
};
export const CategoryStatusEnum = {
  EMPTY: '0',
};
export const NewEditQueryEnum = {
  NEW: '0',
};

export const SourceQueryEnum = {
  STANDARD: 'Standard',
  CUSTOM: 'Custom',
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/CustomQueryEnum.js